import { Component, Prop } from 'vue-property-decorator';
import { mixins } from 'vue-class-component';

import StoreModuleMixin from '@/mixins/StoreModuleMixin';

import CtaLinkItem, { CtaButtonStyle } from '@/common/interfaces/CtaLinkItem';

import CtaButton from '@/components/CtaButton/CtaButton.vue';

import {
  FilterableGridModuleState,
  CURRENT_PAGE_COUNT,
  LOAD_MORE,
} from '../FilterableGridModule.store';

@Component({
  components: { CtaButton },
})
export default class FilterableGridPaging extends mixins(StoreModuleMixin) {
  @Prop({ type: Object as () => CtaLinkItem })
  readonly ctaLink!: CtaLinkItem;

  state!: FilterableGridModuleState;

  loadMore: () => void = this.getAction(LOAD_MORE);

  get showLoadMore() {
    return this.current !== this.total && this.cardsLoaded;
  }

  get ctaText() {
    if (this.state.CtaText) {
      return this.state.CtaText;
    } else {
      return 'Load More';
    }
  }

  get loadMoreCta(): CtaLinkItem {
    const { Paging } = this.state;
    if (Paging.LoadMoreButton) {
      return { ...Paging.LoadMoreButton, Action: 'Custom', ButtonStyle: CtaButtonStyle.White };
    } else {
      return {
        Title: this.ctaText,
        Link: '#',
        Action: 'Custom',
        ButtonStyle: CtaButtonStyle.Black,
      };
    }
  }

  get largeTitle() {
    let largeTitle = '';
    if (this.state.TitleLarge) {
      largeTitle = this.state.TitleLarge;
    }

    return largeTitle;
  }

  get isPaging() {
    if (this.state.Paging) {
      return this.state.Paging;
    }
  }

  get viewCounts() {
    return this.state.Paging.ViewCounts && this.cardsLoaded;
  }

  get current(): number {
    return this.getters(CURRENT_PAGE_COUNT);
  }

  get total() {
    return this.state.Paging.Total;
  }

  get cardsLoaded() {
    return !!this.state.Cards.length;
  }

  get viewMoreLink() {
    return this.state.ViewMoreLink
  }
}
